import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div>
            this is privacy policy
        </div>
    );
};

export default PrivacyPolicy;